import React from "react";

const ProductSearchCard = ({ product }) => {
    return (
        <div className="border p-4 rounded-lg shadow-md hover:shadow-lg transition">
            <img crossOrigin="anonymous" 
                src={product.images[0]}
                alt={product.name}
                className="w-full h-40 object-cover rounded-md"
            />
            <h2 className="text-lg font-semibold mt-2">{product.name}</h2>
            <p className="text-gray-800 font-bold"><span className="current-price">
                ₹ {product.old_price && Math.round( (product.old_price * (100 - product.new_price)) / 100 )}
            </span>
                {product.old_price && (
                    <>
                        <span className="old-price">₹{product.old_price}</span>
                        <span className="discount">{` (${product.new_price}% OFF)`}</span>
                    </>
                )}
            </p>
            <button className="mt-2 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
                Add to Cart
            </button>
        </div>
    );
};

export default ProductSearchCard;
